export const SCRIPT_DELAY_MS = 4000;

// The below enum is used to define the SSR regenerate interval for pages. The values are in seconds.
export const REGENERATE_INTERVAL: Record<string, number> = {
  ONE_HOUR: 60 * 60,
  ONE_DAY: 24 * 60 * 60,
  THREE_DAYS: 3 * 24 * 60 * 60,
  ONE_WEEK: 7 * 24 * 60 * 60,
};

// The below enum cloudfront cache control max age for SSR pages. The values are in seconds.
// 5 mins, 30 mins, 1 hour, 6 hours
export const CLOUDFRONT_CACHE_MAX_AGE: Record<string, number> = {
  FIVE_MINUTES: 5 * 60,
  THIRTY_MINUTES: 30 * 60,
  ONE_HOUR: 60 * 60,
  SIX_HOURS: 6 * 60 * 60,
};
